import { z } from 'zod';

export const RedactionBoxSchema = z.object({
  page: z.number().int().nonnegative(),
  x: z.number().min(0).max(1),
  y: z.number().min(0).max(1),
  w: z.number().positive().max(1),
  h: z.number().positive().max(1),
  label: z.string().max(120).optional(),
  reason: z.string().max(500).optional(),
  target_text: z.string().max(300).nullable().optional(),
});

export const RedactionProposalSchema = z.object({
  boxes: z.array(RedactionBoxSchema).default([]),
  warnings: z.array(z.string()).default([]),
});

export type RedactionBox = z.infer<typeof RedactionBoxSchema>;
export type RedactionProposal = z.infer<typeof RedactionProposalSchema>;
